import React, { Component } from 'react'
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import serializeForm from "form-serialize"
import { Redirect } from 'react-router-dom'
import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'
import * as Validator from '../../utils/helpers/validationPassword'

class LostPasswordConfirm extends Component {
  state = {
    notificationErrorPassword: false,
    notificationSuccessPassword: false,
  }
  handleSubmit = event => {
    event.preventDefault();
    const { match } = this.props
    const FormValues = serializeForm(event.target, { hash: true });

    if (Object.keys(FormValues).length !== 0) {
      if (match && match.params.tokenAccess && match.params.userID) {
        if (Validator.verifyPasswordChar(serializeJavascript.sanitize(FormValues).NewPassword) && Validator.verifyPasswordLowcase(serializeJavascript.sanitize(FormValues).NewPassword) && Validator.verifyPasswordUppercase(serializeJavascript.sanitize(FormValues).NewPassword) && Validator.verifyPasswordNumber(serializeJavascript.sanitize(FormValues).NewPassword) &&
            Validator.verifyPasswordChar(serializeJavascript.sanitize(FormValues).password) && Validator.verifyPasswordLowcase(serializeJavascript.sanitize(FormValues).password) && Validator.verifyPasswordUppercase(serializeJavascript.sanitize(FormValues).password) && Validator.verifyPasswordNumber(serializeJavascript.sanitize(FormValues).password) &&
            serializeJavascript.sanitize(FormValues).NewPassword === serializeJavascript.sanitize(FormValues).password && serializeJavascript.sanitize(FormValues).password.length
        ) {
          backendMembers.resetPwdLong(match.params.userID, match.params.tokenAccess, serializeJavascript.sanitize(FormValues).NewPassword)
          .then(response => {
          })
          .catch(error => {
          })
          this.setState({ notificationSuccessPassword: true })
        }else {
          this.setState({ notificationErrorPassword: true })
        }
      }
    }
  }

  render() {
    const { notificationSuccessPassword, notificationErrorPassword } = this.state

    return(
      <div>
        <Header userIsSuccessLogin={false} />
        <div className="aps-container-center-bloc">
          <div className="aps-section-connexion-padding">
            <div className="uk-section aps-section-connexion">
              {notificationSuccessPassword
                ?
                  <div>
                    <Redirect to='/connexion-apres-confirmation-mot-de-passe/yes' />
                  </div>
                :
                  <div>
                    <h3 className="uk-text-center aps-section-connexion-title">
                      Saisissez votre nouveau mot de passe
                    </h3>
                    {notificationErrorPassword && (
                      <div className="uk-text-center aps-section-lost-password-error-password">
                        Mot de passe non identique ou incorrect (Au moins 08 caratères, une lettre miniscule, une lettre majuscule et un chiffre)
                      </div>
                    )}
                    <form onSubmit={this.handleSubmit}>
                      <div className="uk-text-center aps-section-connexion-fields-container">
                        <div className="uk-inline aps-section-connexion-input-full">
                          <span className="uk-form-icon" uk-icon="icon: lock" />
                          <input
                            className="uk-input aps-section-connexion-input"
                            type="password"
                            placeholder="Nouveau mot de passe"
                            name="NewPassword"
                          />
                        </div>
                      </div>
                      <div className="uk-text-center">
                        <div className="uk-inline aps-section-connexion-input-full">
                          <span className="uk-form-icon" uk-icon="icon: lock" />
                          <input
                            className="uk-input aps-section-connexion-input"
                            type="password"
                            placeholder="Confirmer le mot de passe"
                            name="password"
                          />
                        </div>
                      </div>
                      <div className="uk-text-center aps-section-connexion-action-btn">
                        <button className="uk-button aps-section-connexion-action-btn-full">
                          Valider
                        </button>
                      </div>
                      <div className="uk-text-center">
                        Au moins 08 caratères, une lettre miniscule, une lettre majuscule et un chiffre
                      </div>
                    </form>
                  </div>
              }
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default LostPasswordConfirm



// WEBPACK FOOTER //
// ./src/containers/LostPasswordConfirm/index.js